import { RedirectActionSettings } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/RedirectActionSettings';
import { ActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/ActionController';
import { ActionFeatures } from '../ActionFeatures';
import '../Actions.scss';
export class RedirectActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', '$timeout', '$translate', 'UndoRedoService', 'state', 'CurrentApplicationService', '$rootScope', '$scope', 'typeOfAction'];
    constructor(close, action, $onStateChanged, $timeout, $translate, UndoRedoService, state, CurrentApplicationService, $rootScope, $scope, typeOfAction) {
        super(close, action, $onStateChanged, UndoRedoService, state, $rootScope, $scope, typeOfAction);
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.CurrentApplicationService = CurrentApplicationService;
        this.$rootScope = $rootScope;
        this.isEditing = false;
        this.onToggle = (event) => {
            this.sendContext = event.detail.checked;
            if (this.sendContext && this.redirectForm.context) {
                this.redirectForm.context.$invalid = true;
                this.redirectForm.context.$valid = false;
            }
            this.$scope.$apply();
        };
        this.onContextValueChange = (event) => {
            if (this.action.settings.context) {
                this.action.settings.context.value = event.detail.value;
            }
            this.save();
        };
        this.init();
    }
    async init() {
        this.isActionConditionEnabled = await ActionFeatures.isActionConditionEnabled();
        this.application = await this.CurrentApplicationService.fetchApplicationByStateParams();
        this.$timeout(() => {
            this.redirectForm.address.$setDirty();
            this.checkValidInputs();
        });
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
    }
    checkValidInputs() {
        if (!this.action.settings.address) {
            this.redirectForm.address.$invalid = true;
            this.redirectForm.address.$valid = false;
        }
        if (!this.action.settings.context?.value) {
            this.redirectForm.context.$invalid = true;
            this.redirectForm.context.$valid = false;
        }
    }
    create() {
        return new RedirectActionSettings();
    }
    startEditing() {
        const input = document.getElementById('redirect-title');
        if (input) {
            input.focus();
        }
    }
    onBlur() {
        this.isEditing = false;
        if (this.action.$title.length === 0) {
            this.action.$title = this.$translate.instant('builder-tabs-actions.redirect.title');
            this.save();
        }
    }
    get sendContext() {
        return this.action.settings.context != undefined;
    }
    set sendContext(value) {
        if (value) {
            // We are only supporting text for now.
            if (!this.action.settings.context) {
                this.action.settings.context = {
                    type: 'text/plain',
                    value: '',
                };
            }
        }
        else {
            if (this.action.settings.context) {
                this.action.settings.context = undefined;
            }
        }
    }
}
RedirectActionController.$inject = ['close', 'action', '$onStateChanged', '$timeout', '$translate', 'UndoRedoService', 'state', 'CurrentApplicationService', '$rootScope', '$scope', 'typeOfAction'];
